<script setup lang="ts">
import type { Vehicle } from '~/layers/forms/models'

interface Props {
  model: Vehicle
}
const props = defineProps<Props>()

const data = computed(() => [
  { label: 'Año', value: props.model.year?.toString() },
  { label: 'Uso', value: props.model.use?.name },
  ...(props.model.version ? [{ label: 'Versión', value: props.model.version?.name }] : []),
  {
    label: 'Valor',
    value: props.model.amount.value
      ? `$${formatCurrency({ price: props.model.amount.value })}`
      : undefined,
  },
])
</script>
<template>
  <FormsGlobalResume
    :data
    hint-text="Información del vehículo"
  >
    <template #header>
      <div class="text-center leading-tight flex flex-col justify-center">
        <div class="font-bold text-2xl">{{ model.manufacturer?.name }} </div>
        <div class="text-xs rounded-full bg-white text-surface-950 px-1">
          {{ model.model?.name }}
        </div>
      </div>
    </template>
  </FormsGlobalResume>
</template>
